import FilteredEllipse from '@/assets/svg/Blur';
import Overview from '@/components/screens/Overview';
import SocialLinks from '@/components/screens/SocialLinks';
import ImgSlider from '@/components/slider/ImgSlider';
import HeadingOne from '@/components/ui/headings/HeadingOne';
import { useTranslation } from 'react-i18next';
import MobileAppPanel from '@/components/screens/MobileAppPanel';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getApiBaseUrl, getStorageUrl } from '@/utils/utils';
import Loading from '@/components/ui/Loading';

type Props = {
    title: string;
    banner_phone: string;
    slides: {
        content: string;
        image: string;
    }[];
    shots: {
        image: string;
    }[];
    social: {
        name: string;
        links: string;
    }[];
    slider_store: {
        title: string;
        content: string;
        image: string;
        platforms: string;
    }[];
    description: string;
    results: string;
};

const AmanApp = () => {
    const { t } = useTranslation();
    const { id } = useParams();

    const [data, setdata] = useState<Props>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`${getApiBaseUrl()}/projects/${id}`)
            .then((response) => response.json())
            .then((data) => setdata(data))
            .catch((error) => console.error('Error fetching projects:', error))
            .finally(() => setLoading(false));
    }, [id]);

    console.log('slider', data?.slider_store);

    return (
        <div className="w-full h-full">
            <FilteredEllipse className="!top-[-5%] !left-[-20%]" />
            <div className="flex flex-col h-full w-full">
                <div className="xl:mt-[155px] lg:mt-[140px] mt-[125px]">
                    <div className="mainContainer">
                        {loading ? (
                            <Loading className="my-10" />
                        ) : (
                            <>
                                <HeadingOne headOne={data?.title} className="text-center" />
                                <div className="xl:mt-[87px] lg:mt-[82px] md:mt-[70px] sm:mt-[50px] mt-[32px]">
                                    <ImgSlider slides={data?.slides} />
                                </div>

                                {/* SocialLinks */}
                                <div className="md:mt-[32px] sm:mt-[28px] mt-[24px] flex flex-col items-center">
                                    <p className="lg:text-[24px] md:text-[21] sm:text-[19px] text-[16px] text-main font-bold">
                                        {t('project.page')}
                                    </p>
                                    <ul className="mt-[14px]">
                                        <SocialLinks
                                            social={data?.social_links}
                                            className="flex md:gap-[32px] sm:gap-[24px] gap-[20px]"
                                        />
                                    </ul>
                                </div>

                                {/* Overview */}
                                <div className="head-about mainMargin">
                                    <div className="mainPadding">
                                        {/* Overview */}
                                        <Overview disc={data?.description || ''} />
                                    </div>
                                </div>

                                <div>
                                    <img
                                        src={getStorageUrl(data?.banner_phone)}
                                        alt="تصميم الهاتف"
                                        className="bg-cover"
                                    />
                                </div>

                                {/* Results */}
                                <div className="head-about mainMargin">
                                    <div className="mainPadding">
                                        <h3 className="overviewHead">النتائج:</h3>
                                        <p
                                            className="md:text-[20px] sm:text-[18px] text-[16px] text-Grey1 font-medium"
                                            dangerouslySetInnerHTML={{ __html: data?.results }}
                                        ></p>
                                    </div>
                                </div>

                                {/* Aman Img */}
                                <div className="grid grid-cols-2 lg:gap-6 md:gap-5 gap-4">
                                    {data?.project_images?.map((image, index) => (
                                        <img
                                            key={index}
                                            src={getStorageUrl(image)}
                                            alt="تصميم الهاتف"
                                            className="bg-cover max-h-[420px] h-full lg:rounded-2xl md:rounded-lg sm:rounded-lg rounded-md w-full"
                                        />
                                    ))}
                                </div>
                                {/* {data?.slider_store?.map((item, index) => <MobileAppPanel key={index} slider={item} />)} */}
                                <MobileAppPanel slider={data?.slider_store} />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AmanApp;
